module.exports = __webpack_public_path__ + "static/media/TractorTrolley.65960f95.svg";